import type { Locales } from '@/types/project-types'
import type { AbstractIntlMessages } from 'next-intl'

import merge from 'lodash.merge'

/**
 * Loads the translations app/global-error.tsx needs from the same JSON files
 * `i18n.request.ts` uses.
 *
 * INFO: keep the explicit template-literal imports. Storing the whole path in
 * a variable breaks webpack's static analysis (see i18n.request.ts).
 */
export async function loadGlobalErrorMessages(
  locale: Locales
): Promise<AbstractIntlMessages> {
  const localeLowerCase = locale.toLowerCase()

  const [messagesPackageCommerceBlocks, messagesLocal, messagesOverrides] =
    await Promise.all([
      import(`@maestro/commerce-blocks/i18n/${localeLowerCase}.json`),
      import(`../../i18n/${localeLowerCase}.json`),
      import(`../../i18n/overrides/${localeLowerCase}.json`),
    ])

  return merge(
    {},
    messagesPackageCommerceBlocks.default,
    messagesLocal.default,
    messagesOverrides.default
  )
}

/**
 * Title of the error card, used for the mobile header bar
 */
export function getClientErrorTitle(
  messages: AbstractIntlMessages
): string | undefined {
  const commerceBlocks = messages['commerce-blocks']
  if (typeof commerceBlocks !== 'object') {
    return undefined
  }

  const clientError = commerceBlocks['client-error']
  if (typeof clientError !== 'object') {
    return undefined
  }

  const title = clientError.title

  return typeof title === 'string' ? title : undefined
}
